var exports = {
  "zr": "TaskComments.module__root___cHd2a3",
  "R_": "TaskComments.module__heading___cHd2a3",
  "U9": "TaskComments.module__count___cHd2a3",
  "Ie": "TaskComments.module__empty___cHd2a3",
  "p_": "TaskComments.module__list___cHd2a3",
  "Im": "TaskComments.module__comment___cHd2a3",
  "oS": "TaskComments.module__avatarBlank___cHd2a3",
  "Tq": "TaskComments.module__bubble___cHd2a3",
  "mI": "TaskComments.module__meta___cHd2a3",
  "cy": "TaskComments.module__author___cHd2a3",
  "kB": "TaskComments.module__time___cHd2a3",
  "Q2": "TaskComments.module__delete___cHd2a3",
  "Qq": "TaskComments.module__text___cHd2a3",
  "Vx": "TaskComments.module__composerWrap___cHd2a3",
  "Tw": "TaskComments.module__tagList___cHd2a3",
  "GI": "TaskComments.module__tagItem___cHd2a3",
  "pm": "TaskComments.module__tagItemOn___cHd2a3",
  "lE": "TaskComments.module__mention___cHd2a3",
  "DA": "TaskComments.module__composer___cHd2a3",
  "me": "TaskComments.module__me___cHd2a3",
  "hF": "TaskComments.module__input___cHd2a3",
  "tN": "TaskComments.module__send___cHd2a3",
};

module.exports = exports;
